<template>
    <div id="edit_appraisal">
        <h1 class="ui header">
            <!-- 編輯考績 -->
            {{ $t('ui.page_titles.edit_appraisal') }}
        </h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <!-- 分數 -->
                    <label>{{ $t('ui.pages.appraisals.point') }}</label>
                    <input type="number" v-model="appraisal.point">
                </div>
                <div class="field">
                    <!-- 事由 -->
                    <label>{{ $t('ui.pages.appraisals.point') }}</label>
                    <input type="text" v-model="appraisal.reason">
                </div>
                <button class="ui basic positive button" @click.prevent="update">{{ $t('ui.general.update') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function () {
        return {
            is_initialized: false,
            is_processing: false,
            appraisal: {},
            errors: [],
        }
    },
    created: function() {
        this.init();
    },
    mounted: function() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "edit_appraisal") {
                this.init();
            }
        },
    },
    computed: {
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized =  false;
                that.is_processing =  false;
                that.appraisal =  {};
                that.errors =  [];
                resolve();
            });
            await that.fetch_appraisal();
            await new Promise(resolve => {
                that.is_initialized = true;
            });
        },
        fetch_appraisal: function() {
            var that = this;
            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_appraisal).parse(
                {
                    "appraisal_identity": that.$route.params.identity,
                },
                ""
            );
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    that.appraisal = response.data.appraisal;
                })
                .catch(function (error) {
                    // that.$noty.error('取得考績資訊失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name',{
                            name: that.$t('models.appraisals'),
                            reason: ': ' + error
                        })
                    );
                    return Promise.reject(error);
                });
        },
        update: function() {
            var that = this;
            that.is_processing = true;
            that.errors = [];
            // Prepare parameters
            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_appraisal_update).parse(
                {
                    "appraisal_identity": that.$route.params.identity,
                },
                ""
            );
            var params = that.appraisal;

            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(function (response) {
                if (response.data.status == "success") {
                    that.$parent.init();
                    that.$router.push('/provider/appraisals/' + that.$route.params.staff_identity);
                    // that.$noty.success("考績更新成功");
                    that.$noty.success(
                        that.$t('ui.notifications.success.update__name', {
                            name: that.$t('models.appraisals')
                        })
                    );
                } else {
                    // that.$noty.error("考績更新失敗");
                    that.$noty.error(
                        that.$t('ui.notifications.error.update__name', {
                            name: that.$t('models.appraisals'),
                            reason: ': ' + response.data.errors
                        })
                    );
                    that.errors = response.data.errors;
                }
            })
            .catch(function (error) {
                if (!error.response) {
                    // Network Error
                    that.$noty.error(
                        that.$t('ui.general.network_abnormality')+": "+
                        that.$t('ui.general.server_offline')
                    );
                } else {
                    that.$noty.error(that.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data);
                }
            });
            that.is_processing = false;
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
